<template>
  <div class="how-carousel-outer" ref="carousel-outer">
    <div
      ref="carousel-items"
      class="how-carousel-outer__slides"
      :style="`--i:${slidesTranslateValue};--n:${slidesCount}`">
      <slot />
    </div>
    <nav class="how-carousel-nav" v-if="isScrollable">
      <a href="#"
        class="how-carousel-arrow how-carousel-arrow--left mr-3"
        v-on:click.prevent="slideLeft()"
        :class="{'how-carousel-arrow--disabled': currentSlide === 0}"
      >left</a>
      <a href="#"
        class="how-carousel-arrow how-carousel-arrow--right"
        v-on:click.prevent="slideRight()"
        :class="{'how-carousel-arrow--disabled': currentSlide === (slidesCount - 1)}"
      >right</a>
    </nav>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slidesOuter: null,
      slidesInner: null,
      slideSize: 200,
      slidesCount: 5,
      currentSlide: 0,
      interval: null,
      scrollFrom: null,
      scrollTo: null,
      locked: false,
      slidesTranslateValue: 0,
      isScrollable: false
    }
  },
  mounted() {
    this.checkScrollAvailable()
    window.addEventListener('resize', this.checkScrollAvailable)
  },
  beforeDestroy() {
    this.destroyEvents()
    window.removeEventListener('resize', this.checkScrollAvailable)
  },
  methods: {
    checkScrollAvailable() {
      this.slidesOuter = this.$refs['carousel-outer']
      this.slidesInner = this.$refs['carousel-items']
      const innerWidth = this.slidesInner.offsetWidth
      const outerWidth = this.slidesOuter.offsetWidth

      if (innerWidth > outerWidth) {
        this.isScrollable = true
        this.initEvents()
      } else {
        this.currentSlide = 1
        this.slideLeft()
        this.isScrollable = false
        this.destroyEvents()
      }
    },
    slideRight() {
      if (this.currentSlide < this.slidesCount - 1) {
        this.currentSlide++
        this.slidesTranslateValue = this.currentSlide
      }
    },
    slideLeft() {
      if (this.currentSlide > 0) {
        this.currentSlide--
        this.slidesTranslateValue = this.currentSlide
      }
    },
    eventValue(e) {
      return e.changedTouches ? e.changedTouches[0] : e
    },
    handleMouseMove(e) {
      if (this.locked) {
        const event = this.eventValue(e)
        const scrolled = event.clientX.toFixed(0)
        const scrolledPerc = (((this.scrollFrom - scrolled) / (this.slideSize / 100)) * 0.01).toFixed(2)

        this.slidesTranslateValue = +this.currentSlide + +scrolledPerc
      }
    },
    handleMouseDown(e) {
      const event = this.eventValue(e)
      const scrolled = event.clientX.toFixed(0)

      this.locked = true
      this.scrollFrom = scrolled
    },
    handleMouseUp(e) {
      if (this.locked) {
        const event = this.eventValue(e)
        const scrolled = event.clientX.toFixed(0)

        if (+this.scrollFrom > +scrolled) {
          this.slideRight()
        } else if (+this.scrollFrom < +scrolled) {
          this.slideLeft()
        }

        this.scrollFrom = 0
        this.slidesTranslateValue = this.currentSlide
        this.locked = false
      }
    },
    destroyEvents() {
      this.slidesOuter.removeEventListener('mousedown', this.handleMouseDown, false)
      this.slidesOuter.removeEventListener('touchstart', this.handleMouseDown, false)
      this.slidesOuter.removeEventListener('mousemove', this.handleMouseMove, false)
      this.slidesOuter.removeEventListener('touchmove', this.handleMouseMove, false)
      window.removeEventListener('mouseup', this.handleMouseUp, false)
      window.removeEventListener('touchend', this.handleMouseUp, false)
    },
    initEvents() {
      this.slidesOuter.addEventListener('mousedown', this.handleMouseDown, false)
      this.slidesOuter.addEventListener('touchstart', this.handleMouseDown, false)
      this.slidesOuter.addEventListener('mousemove', this.handleMouseMove, false)
      this.slidesOuter.addEventListener('touchmove', this.handleMouseMove, false)
      window.addEventListener('mouseup', this.handleMouseUp, false)
      window.addEventListener('touchend', this.handleMouseUp, false)
    }
  }
}
</script>
